import { DATE_IMAGE_SELECTED } from '../../action-types/ui/dateImageSelected';

export const dateImageSelected = flag => ({
  type: DATE_IMAGE_SELECTED,
  flag,
});




// WEBPACK FOOTER //
// ./src/redux/actions/ui/dateImageSelected.js